import React from 'react'

const AppleIcon = props => (
  <svg viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.39127 2.50051C4.47387 2.7366 4.53128 2.97961 4.56696 3.21676C4.72497 3.20804 4.88237 3.18458 5.03707 3.14639C7.1256 2.63008 8.87251 2.82806 8.84921 6.76636C8.84921 8.78307 6.95285 11.3976 4.9672 10.9492C4.6099 10.8697 4.23947 10.8697 3.88218 10.9492C1.90041 11.3976 0.0118061 8.78307 0.000160035 6.76636C-0.01925 2.82806 1.7296 2.63008 3.81618 3.14639C3.9332 3.17528 4.05176 3.19574 4.17096 3.20777C4.05526 2.50036 3.72467 1.75511 3.06907 1.40525C3.04651 1.39327 3.02653 1.37697 3.01028 1.35726C2.99402 1.33756 2.9818 1.31485 2.97432 1.29043C2.96684 1.26601 2.96425 1.24035 2.96668 1.21493C2.96912 1.1895 2.97654 1.1648 2.98852 1.14225C3.01271 1.09669 3.05402 1.06261 3.10334 1.0475C3.12776 1.04002 3.15342 1.03742 3.17884 1.03986C3.20427 1.04229 3.22897 1.04971 3.25153 1.06169C3.7279 1.31589 4.05879 1.73691 4.27497 2.21059L4.34452 1.74691C4.4038 1.33733 4.59345 0.957755 4.88538 0.664427C5.17731 0.371099 5.55598 0.179632 5.96526 0.118401L6.75914 0L6.64074 0.793872C6.57955 1.20169 6.38904 1.57908 6.09727 1.8705C5.8055 2.16192 5.42788 2.35197 5.01999 2.41267L4.39127 2.50051Z"
      fill="url(#paint0_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="4.42472"
        y1="0"
        x2="4.42472"
        y2="11"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
)

export default AppleIcon
